module.exports = __webpack_public_path__ + "static/media/_title_17.a7416b5d.svg";